import React from 'react';
import { Languages } from 'lucide-react';
import { useLanguageFromUrl } from '../../hooks/useLanguageFromUrl';
import { classNames } from '../../utils/classNames';

export const LanguageSwitcher = () => {
  const { language, setLanguageInUrl } = useLanguageFromUrl();
  const options = [
    { value: 'fa', label: 'FA', icon: true },
    { value: 'en', label: 'EN' }
  ];

  return (
    <div
      className="inline-flex items-center gap-1 rounded-full border border-border bg-panel-strong p-1 shadow-sm backdrop-blur-xl"
      aria-label="Language"
    >
      {options.map((option) => {
        const isActive = language === option.value;

        return (
          <button
            key={option.value}
            type="button"
            onClick={() => setLanguageInUrl(option.value)}
            className={classNames(
              'inline-flex min-h-9 items-center justify-center gap-1.5 rounded-full px-3 text-xs font-bold transition',
              isActive
                ? 'bg-accent text-white shadow-sm dark:text-slate-950'
                : 'text-muted hover:bg-accent-soft hover:text-text'
            )}
            aria-pressed={isActive}
          >
            {option.icon ? <Languages size={15} /> : null}
            {option.label}
          </button>
        );
      })}
    </div>
  );
};
